import * as types from "./types";
import { combineReducers } from "redux";
import _ from "lodash";

function dataSaved(state = { status: false, message: "" }, action) {
  switch (action.type) {
    case types.DATA_SAVED:
      return action.payload;
    case types.RESET_DATA_SAVED:
      return { status: false, message: "" };
    default:
      return state;
  }
}

function listaColegios(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH:
      let data = _.cloneDeep(state);
      data.push(payload);
      return data;

    case types.REMOVED:
      let datos = _.cloneDeep(state);
      let resp = datos.filter(item => item.id !== payload);
      return resp;

    case types.RESET:
      return [];

    default:
      return state;
  }
}

function detalleColegio(state = {}, { type, payload }) {
  return type === types.FETCH_DETALLE
    ? payload
    : type === types.RESET_DETALLE
      ? {}
      : state;
}

const reducer = combineReducers({
  dataSaved,
  listaColegios,
  detalleColegio
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/colegios/reducers.js